// General
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';

// Async Thunk
export const getCities = createAsyncThunk('getgeneralapi_city', async ({ signal = null }) => {
  try {
    const res = await axios.get(`https://turkiyeapi.dev/api/v1/provinces`, { signal });
    return res.data.data.map(item => item.name);
  } catch (error) { throw error; }
});
export const getDistricts = createAsyncThunk('getgeneralapi_district', async ({ signal = null, city }) => {
  try {
    const res = await axios.get(`https://turkiyeapi.dev/api/v1/provinces?name=${city}`, { signal });
    return res.data.data[0].districts.map(item => item.name);
  } catch (error) { throw error; }
});

// Slice
const LocationSlice = createSlice({
  name: 'location',
  initialState: {
    cities: [],
    districts: [],
    cityStatus: '',
    districtStatus: '',
    error: ''
  },
  reducers: {
    resetStatus: (state) => { state.cityStatus = null; state.districtStatus = null; },
    resetError: (state) => { state.error = null; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCities.pending, (state) => { state.cityStatus = 'loading'; })
      .addCase(getCities.fulfilled, (state, action) => { state.cityStatus = 'fulfilled'; state.cities = action.payload || []; })
      .addCase(getCities.rejected, (state, action) => { state.cityStatus = 'rejected'; state.error = action.error.message; })
      .addCase(getDistricts.pending, (state) => { state.districtStatus = 'loading'; })
      .addCase(getDistricts.fulfilled, (state, action) => { state.districtStatus = 'fulfilled'; state.districts = action.payload || []; })
      .addCase(getDistricts.rejected, (state, action) => { state.districtStatus = 'rejected'; state.error = action.error.message; });
  }
});

export const { resetStatus, resetError } = LocationSlice.actions;
export default LocationSlice.reducer;